import React, { useLayoutEffect, useRef, useState } from "react";

export const ReadMore = ({ text, className = "" }) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [long, setLong] = useState(false);
  useLayoutEffect(() => {
    if (ref.current && !open) setLong(ref.current.scrollHeight > ref.current.clientHeight + 1);
  }, [text, open]);
  return (
    <div className={className}>
      <p ref={ref} data-testid="comment-text" onClick={() => long && setOpen(!open)} className={`whitespace-pre-wrap break-words ${open ? "" : "line-clamp-4"} ${long ? "cursor-pointer" : ""}`}>{text}</p>
      {long && !open && (
        <button type="button" data-testid="comment-readmore" onClick={() => setOpen(true)} className="mt-1 text-xs font-medium text-[#F3D2D9] underline-offset-2 hover:underline">… Lire plus</button>
      )}
    </div>
  );
};
